/**
 * Z-index scale — keep in sync with tailwind.config.js theme.extend.zIndex.
 * Use these for inline styles. For className-based usage, use the Tailwind
 * classes directly: z-modal, z-nested, z-dropdown, z-tooltip, z-overlay, z-onboarding.
 */
export const zIndex = {
  modal: 30,
  nested: 50,
  dropdown: 100,
  tooltip: 150,
  overlay: 200,
  onboarding: 10000000000,
} as const
